import { Injectable, signal } from '@angular/core';

export type NotificationLevel = 'success' | 'info' | 'warning' | 'error';

export interface AppNotification {
  readonly id: number;
  readonly level: NotificationLevel;
  readonly message: string;
}

const AUTO_DISMISS_MS = 5000;

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private nextId = 0;
  private readonly _items = signal<readonly AppNotification[]>([]);
  readonly items = this._items.asReadonly();

  success(message: string): void {
    this.push('success', message);
  }

  info(message: string): void {
    this.push('info', message);
  }

  warning(message: string): void {
    this.push('warning', message);
  }

  error(message: string): void {
    this.push('error', message);
  }

  dismiss(id: number): void {
    this._items.update((items) => items.filter((item) => item.id !== id));
  }

  private push(level: NotificationLevel, message: string): void {
    const id = ++this.nextId;
    this._items.update((items) => [...items, { id, level, message }]);
    setTimeout(() => this.dismiss(id), AUTO_DISMISS_MS);
  }
}
